export function hexToHsl(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255;
  const g = ((n >> 8) & 255) / 255;
  const b = (n & 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}

export function applyBrandColor(hex) {
  const root = document.documentElement;
  const parsed = hexToHsl(hex);
  if (!parsed) {
    root.style.removeProperty("--primary");
    root.style.removeProperty("--primary-foreground");
    root.style.removeProperty("--ring");
    return;
  }
  const { h, s, l } = parsed;
  root.style.setProperty("--primary", `${h} ${s}% ${l}%`);
  root.style.setProperty("--primary-foreground", l > 60 ? "0 0% 4%" : "0 0% 98%");
  root.style.setProperty("--ring", `${h} ${s}% ${l}%`);
}

export function initBrandColor() {
  try {
    const saved = JSON.parse(localStorage.getItem("caus_brand") || "null");
    if (saved?.primary) applyBrandColor(saved.primary);
  } catch {
    /* sin marca guardada */
  }
}
